import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";

//import {BiSupport} from "react-icons/bi";
import {TbChecklist, TbHomeHeart} from "react-icons/tb";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbHomeHeart  className='nav-icon' /></div>
                    <span className="text-small-2 ">خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/requests">
                    <div><TbChecklist  className='nav-icon' /></div>
                    <span className="text-small-2 ">سفارش ها</span>
                </NavLink>
{/*                <NavLink className="nav-item nav-link  " to="/orders">
                    <div><BiSupport  className='nav-icon' /></div>
                    <span className="text-small-2 ">پشتیبانی</span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><RiUserSettingsLine  className='nav-icon' /></div>
                    <span className="text-small-2 ">حساب من</span>
                </NavLink>

            </nav>
        </React.Fragment>
    );
};

export default Navbar;
